// Types
import type { AppLocale } from "@citizenm/foundation/shared/types/contentful";

export default async function useLegacyLocalizedSlugs(
  contentfulId?: MaybeRef<string>,
) {
  const _contentfulId = unref(contentfulId);

  if (!_contentfulId) {
    return null;
  }

  return useFetch(`/api/v2/slugs/page/${_contentfulId}`, {
    key: `contentful-page-slugs-${_contentfulId}`,
    transform: (response) => {
      return Object.entries(response).reduce<
        Partial<Record<AppLocale, string>>
      >(
        (acc, [key, value]) => ({
          ...acc,
          [getLocaleKeyByValue(key)]: value,
        }),
        {},
      );
    },
  });
}
